import React from 'react';
import { faClipboardCheck, faStar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import styles from './MembershipsTabs.module.scss';

export type MembershipsTabId = 'memberships' | 'benefit_usage';

const TABS = [
    { id: 'memberships' as const, label: 'Memberships & Packages', icon: faStar },
    { id: 'benefit_usage' as const, label: 'Benefit Usage', icon: faClipboardCheck }
];

interface MembershipsTabsProps {
    value: MembershipsTabId;
    onChange: (value: MembershipsTabId) => void;
}

const MembershipsTabs: React.FC<MembershipsTabsProps> = ({ value, onChange }) => (
    <div
        className={styles.root}
        role="tablist"
    >
        {TABS.map(tab => (
            <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={value === tab.id}
                className={clsx(styles.tab, { [styles.selected]: value === tab.id })}
                onClick={() => onChange(tab.id)}
            >
                <FontAwesomeIcon icon={tab.icon} />
                {tab.label}
            </button>
        ))}
    </div>
);

export default MembershipsTabs;
